import React from 'react';
import BiddingRuleTripadvisor from '../BiddingRule/Metasearch/BiddingRuleTripadvisor';
import BiddingRuleTrivago from '../BiddingRule/Metasearch/BiddingRuleTrivago';
import BiddingRuleGoogleHotelAds from "./Metasearch/BiddingRuleGoogleHotelAds";
import NewTemplateForm from '../TemplateCreationForm/NewTemplateForm';

const BiddingRuleManager = ({biddingRuleData, action, actionType, onClose, onRefresh, showSnackbar }) => {

    let idplf;

    if (biddingRuleData.bidding_rule_type === 'TRIPADVISOR_BIDDING_RULE') {
        idplf = 1;
    } else if (biddingRuleData.bidding_rule_type === 'TRIVAGO_BIDDING_RULE') {
        idplf = 6;
    } else if (biddingRuleData.bidding_rule_type === 'GOOGLE_BIDDING_RULE') {
        idplf = 4;
    }

    const getAlertForm = () => {
        if (biddingRuleData.bidding_rule_type === 'TRIPADVISOR_BIDDING_RULE') {
            if (action === 'rule-action') {
                return <BiddingRuleTripadvisor
                    biddingRuleData={biddingRuleData}
                    onClose={onClose}
                    onRefresh={onRefresh}
                    actionType={actionType}
                    showSnackbar={showSnackbar}
                />;
            } else if (action === 'template-action') {
                return <NewTemplateForm onClose={onClose} idplf={idplf} showSnackbar={showSnackbar} />;
            } else {
                return <p style={{color: "red", paddingLeft: "18px"}} >Unsupported action for Tripadvisor</p>;
            }

        } else if (biddingRuleData.bidding_rule_type === 'TRIVAGO_BIDDING_RULE') {
            if (action === 'rule-action') {
                return <BiddingRuleTrivago
                    biddingRuleData={biddingRuleData}
                    onClose={onClose}
                    onRefresh={onRefresh}
                    actionType={actionType}
                    showSnackbar={showSnackbar}/>;
            } else if (action === 'template-action') {
                return <NewTemplateForm onClose={onClose} idplf={idplf} showSnackbar={showSnackbar} />;
            } else {
                return <p style={{color: "red", paddingLeft: "18px"}} >Unsupported action for Trivago</p>;
            }

        } else if (biddingRuleData.bidding_rule_type === 'GOOGLE_BIDDING_RULE') {
            if (action === 'rule-action') {
                return <BiddingRuleGoogleHotelAds
                    biddingRuleData={biddingRuleData}
                    onClose={onClose}
                    onRefresh={onRefresh}
                    actionType={actionType}
                    showSnackbar={showSnackbar}/>;
            } else if (action === 'template-action') {
                return <NewTemplateForm onClose={onClose} idplf={idplf} showSnackbar={showSnackbar} />;
            } else {
                return <p style={{color: "red", paddingLeft: "18px"}} >Unsupported action for Google</p>;
            }

        } else {
            return <p style={{color: "red", paddingLeft: "18px"}} >Unsupported alert type</p>;
        }
    };

    return (
        <div>
            {getAlertForm()}
        </div>
    );
};

export default BiddingRuleManager;
